/** @jsx jsx */
/** @jsxRuntime classic */

import { jsx } from '@emotion/react';
import React from 'react';
import Button, { Props as ButtonProps } from '../Button/Button';

export type Props = ButtonProps;

const DEFAULT_ID = 'ButtonSmall';

const ButtonSmall: React.FC<ButtonProps> = (componentProps: ButtonProps) => {
  const sx = { height: '34px', minHeight: '34px' };
  const { dataTestId, children, ...props } = componentProps;
  return (
    <Button
      typography="postscript"
      weight="bold"
      data-testid={dataTestId || DEFAULT_ID}
      sx={sx}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ButtonSmall;
